import {SelectOption} from "./select/select.component";
import {LanguageDefinition} from "./language-definition";
import {languageName} from "./language-name";
import {environment} from "../../environments/environment";

export const SUPPORTED_LANGUAGES: LanguageDefinition[] = [];

export function populateLanguages(definitions: LanguageDefinition[]) {
  SUPPORTED_LANGUAGES.length = 0;
  SUPPORTED_LANGUAGES.push(...definitions);
}

export function languageSelectionOptions(): SelectOption[] {
  return SUPPORTED_LANGUAGES.map(language => ({
    value: language.code,
    text: languageOptionText(language),
    localize: false
  }));
}

export function languageOptionText(language: LanguageDefinition): string {
  const name = languageName(language.code, environment.language);
  return language.flag === "" ? name : `${language.flag} ${name}`;
}
